import { currentLocale, usesEnglishContentFallback, tr } from '../services/i18n.js';

export const PROFILE_DATASET = {
  competition: 'Coupe du Monde 2026',
  updatedAt: '2026-06-07',
  sourceNote: 'Sources: FIFA, UEFA et fédérations; synthèse éditoriale Foot-débrief datée, à relire avant chaque match.'
};

export const TEAM_PROFILES = [
  {
    id: 'france',
    name: 'France',
    code: 'FRA',
    group: 'Europe',
    status: 'Profil complet',
    coach: {
      name: 'Didier Deschamps',
      roleSince: '2012',
      formation: 'Ancien milieu défensif, culture bloc-équipe et compétition courte.',
      record: 'Champion du monde 2018, finaliste 2022.',
      source: 'FIFA'
    },
    preferredSystems: ['4-2-3-1', '4-3-3', '4-4-2 hybride'],
    paniniLine: 'Sélection de gestion, forte dans les temps faibles et les transitions.',
    attack: 'Cherche vite les attaquants dans les intervalles, avec beaucoup de valeur donnée aux courses profondes et aux duels côté fort.',
    midfield: 'Double pivot ou triangle flexible pour protéger les pertes, fixer le tempo et libérer les profils créatifs entre les lignes.',
    defense: 'Bloc médian compact, défense de surface robuste, pression plus sélective que permanente selon le contexte du match.',
    transitions: 'Très dangereuse après récupération : première passe verticale, appels dans le dos, finition rapide.',
    strengths: ['Expérience des matchs à élimination', 'Transitions offensives', 'Gestion émotionnelle'],
    risks: ['Animation placée parfois prudente', 'Dépendance aux profils de rupture'],
    tags: ['bloc médian', 'transition', 'gestion']
  },
  {
    id: 'argentina',
    name: 'Argentine',
    code: 'ARG',
    group: 'Amérique du Sud',
    status: 'Profil complet',
    coach: {
      name: 'Lionel Scaloni',
      roleSince: '2018',
      formation: 'Sélectionneur pragmatique, passé par le staff avant de stabiliser le groupe.',
      record: 'Champion du monde 2022, Copa América 2021 et 2024.',
      source: 'FIFA'
    },
    preferredSystems: ['4-3-3', '4-4-2', '4-2-3-1'],
    paniniLine: 'Championne sortante, capable de passer du contrôle calme au duel intense.',
    attack: 'Attaque relationnelle, beaucoup d’appuis courts, de compensations et de liberté autour du meneur axial.',
    midfield: 'Milieu dense, agressif à la perte, construit pour protéger les créateurs et gagner les seconds ballons.',
    defense: 'Bloc discipliné, latéraux mesurés, défense axiale forte dans les duels et les couvertures.',
    transitions: 'Alterner conservation et accélération : l’équipe sait casser le rythme puis attaquer l’espace.',
    strengths: ['Culture gagnante', 'Milieu très compétitif', 'Variété des rythmes'],
    risks: ['Gestion de la succession générationnelle', 'Création si le centre est fermé'],
    tags: ['contrôle', 'duel', 'rythme']
  },
  {
    id: 'brazil',
    name: 'Brésil',
    code: 'BRA',
    group: 'Amérique du Sud',
    status: 'Profil complet',
    coach: {
      name: 'Carlo Ancelotti',
      roleSince: '2025',
      formation: 'Manager de très haut niveau, culture d’adaptation et de liberté encadrée.',
      record: 'Multiple vainqueur de la Ligue des champions avec plusieurs clubs.',
      source: 'FIFA'
    },
    preferredSystems: ['4-3-3', '4-2-3-1', '4-4-2 losange'],
    paniniLine: 'Talent pur, désormais cadré par une gestion très expérimentée.',
    attack: 'Liberté pour les ailiers et les créateurs, recherche des isolations favorables et des renversements rapides.',
    midfield: 'Structure souvent équilibrée : un socle de sécurité derrière des profils capables de porter ou casser une ligne.',
    defense: 'Bloc plus patient, volonté de limiter les matchs ouverts et de mieux protéger les transitions adverses.',
    transitions: 'Fort potentiel dès la récupération, surtout si les premiers relais trouvent les côtés en un temps.',
    strengths: ['Un contre un offensif', 'Qualité technique', 'Expérience du coach'],
    risks: ['Équilibre attaque-défense', 'Pressing parfois discontinu'],
    tags: ['talent', 'largeur', 'équilibre']
  },
  {
    id: 'england',
    name: 'Angleterre',
    code: 'ENG',
    group: 'Europe',
    status: 'Profil complet',
    coach: {
      name: 'Thomas Tuchel',
      roleSince: '2025',
      formation: 'Coach de club très structurant, habitué aux animations hybrides.',
      record: 'Vainqueur Ligue des champions et Coupe du monde des clubs avec Chelsea.',
      source: 'FIFA'
    },
    preferredSystems: ['3-4-2-1', '4-2-3-1', '4-3-3'],
    paniniLine: 'Effectif premium, coach très interventionniste dans les détails tactiques.',
    attack: 'Recherche de supériorités entre les lignes, alternance largeur stricte et joueurs intérieurs dans les demi-espaces.',
    midfield: 'Double pivot ou milieu à trois pour sécuriser la première relance et libérer les profils offensifs.',
    defense: 'Pressing organisé par zones, volonté de défendre en avançant sans exposer l’axe trop tôt.',
    transitions: 'Peut attaquer très vite si les récupérations trouvent les créateurs face au jeu.',
    strengths: ['Profondeur de banc', 'Coups de pied arrêtés', 'Flexibilité système'],
    risks: ['Automatismes de sélection', 'Pression médiatique'],
    tags: ['hybride', 'pressing', 'demi-espaces']
  },
  {
    id: 'spain',
    name: 'Espagne',
    code: 'ESP',
    group: 'Europe',
    status: 'Profil complet',
    coach: {
      name: 'Luis de la Fuente',
      roleSince: '2022',
      formation: 'Culture fédérale espagnole, fort lien avec les générations jeunes.',
      record: 'Champion d’Europe 2024.',
      source: 'Fédération / UEFA'
    },
    preferredSystems: ['4-3-3', '4-2-3-1'],
    paniniLine: 'Possession moins dogmatique, plus verticale et plus tranchante.',
    attack: 'Largeur importante, ailiers agressifs, jeu intérieur pour attirer puis accélérer côté opposé.',
    midfield: 'Milieu technique qui contrôle les intervalles, garde la balle sous pression et prépare le contre-pressing.',
    defense: 'Contre-pressing haut après perte, ligne défensive avancée si la pression sur porteur est bonne.',
    transitions: 'Récupérations hautes valorisées, mais capacité à calmer immédiatement si la situation n’est pas nette.',
    strengths: ['Maîtrise collective', 'Ailiers percutants', 'Contre-pressing'],
    risks: ['Espace dans le dos', 'Duels défensifs isolés'],
    tags: ['possession', 'largeur', 'contre-pressing']
  },
  {
    id: 'portugal',
    name: 'Portugal',
    code: 'POR',
    group: 'Europe',
    status: 'Profil complet',
    coach: {
      name: 'Roberto Martínez',
      roleSince: '2023',
      formation: 'Sélectionneur porté sur la possession et les structures modulables.',
      record: 'Longue expérience internationale avec la Belgique puis le Portugal.',
      source: 'Fédération / UEFA'
    },
    preferredSystems: ['3-4-3', '4-3-3', '4-2-3-1'],
    paniniLine: 'Génération très riche, capable de changer de costume sans changer de match.',
    attack: 'Beaucoup de rotations entre latéraux, milieux et joueurs de couloir pour créer des surnombres.',
    midfield: 'Milieu créatif, souvent chargé de fixer et d’orienter vers les zones de finition.',
    defense: 'Structure à trois ou quatre selon phase, avec attention forte aux couvertures derrière les latéraux.',
    transitions: 'Transitions offensives très dangereuses si les joueurs de couloir partent lancés.',
    strengths: ['Variété offensive', 'Qualité de passe', 'Banc profond'],
    risks: ['Équilibre des stars', 'Défense des pertes hautes'],
    tags: ['rotation', 'création', 'largeur']
  },
  {
    id: 'germany',
    name: 'Allemagne',
    code: 'GER',
    group: 'Europe',
    status: 'Profil complet',
    coach: {
      name: 'Julian Nagelsmann',
      roleSince: '2023',
      formation: 'Coach moderne, très porté sur les structures asymétriques.',
      record: 'Expérience haut niveau en Bundesliga et sélection.',
      source: 'Fédération / UEFA'
    },
    preferredSystems: ['4-2-3-1', '3-4-2-1', '4-3-3'],
    paniniLine: 'Projet jeune, agressif, avec beaucoup d’idées dans l’occupation des zones.',
    attack: 'Jeu positionnel mobile, créations dans les demi-espaces, latéral ou central qui peut casser la structure.',
    midfield: 'Base technique pour ressortir proprement, puis verticalité rapide vers les joueurs entre les lignes.',
    defense: 'Pressing haut ambitieux, couverture préventive indispensable pour ne pas subir les longs ballons.',
    transitions: 'Contre-pressing très recherché, quitte à accepter une part de risque derrière.',
    strengths: ['Structure travaillée', 'Pressing', 'Jeunes profils explosifs'],
    risks: ['Espace derrière la ligne', 'Stabilité sous pression'],
    tags: ['asymétrie', 'pressing haut', 'verticalité']
  },
  {
    id: 'morocco',
    name: 'Maroc',
    code: 'MAR',
    group: 'Afrique',
    status: 'Profil complet',
    coach: {
      name: 'Walid Regragui',
      roleSince: '2022',
      formation: 'Coach de sélection pragmatique, fort sur l’identité collective.',
      record: 'Demi-finaliste de la Coupe du monde 2022.',
      source: 'FIFA / Fédération'
    },
    preferredSystems: ['4-1-4-1', '4-3-3', '4-2-3-1'],
    paniniLine: 'Bloc solidaire, transitions rapides, émotion collective très forte.',
    attack: 'Sorties rapides vers les côtés, recherche des joueurs capables de gagner du terrain balle au pied.',
    midfield: 'Milieu de protection, utile pour fermer l’axe puis accompagner les transitions.',
    defense: 'Bloc médian/bas très compact, défense courageuse de la surface et gros travail des couloirs.',
    transitions: 'Projection immédiate après récupération, surtout quand l’adversaire a beaucoup engagé.',
    strengths: ['Solidité collective', 'Transitions', 'Mental compétition'],
    risks: ['Création face à bloc bas', 'Fatigue défensive si trop subi'],
    tags: ['bloc compact', 'transition', 'couloirs']
  },
  {
    id: 'usa',
    name: 'États-Unis',
    code: 'USA',
    group: 'Amérique du Nord',
    status: 'Profil complet',
    coach: {
      name: 'Mauricio Pochettino',
      roleSince: '2024',
      formation: 'Coach intense, axé pressing, verticalité et exigence physique.',
      record: 'Expérience majeure en Premier League, Ligue 1 et coupes européennes.',
      source: 'Fédération / FIFA'
    },
    preferredSystems: ['4-2-3-1', '4-3-3'],
    paniniLine: 'Pays hôte avec énergie, pressing et jeunes profils de transition.',
    attack: 'Jeu direct quand l’espace apparaît, volonté de mettre du rythme et d’attaquer les couloirs vite.',
    midfield: 'Milieu athlétique, souvent déterminant pour presser, couvrir et alimenter les courses vers l’avant.',
    defense: 'Pression haute souhaitée, bloc qui doit rester compact pour éviter les distances entre lignes.',
    transitions: 'Très bon terrain pour Pochettino : récupération, course verticale, attaque rapide.',
    strengths: ['Intensité', 'Athlétisme', 'Effet pays hôte'],
    risks: ['Maîtrise face aux blocs posés', 'Gestion des temps faibles'],
    tags: ['pressing', 'vitesse', 'hôte']
  },
  {
    id: 'mexico',
    name: 'Mexique',
    code: 'MEX',
    group: 'Amérique du Nord',
    status: 'Profil complet',
    coach: {
      name: 'Javier Aguirre',
      roleSince: '2024',
      formation: 'Sélectionneur expérimenté, profil pragmatique et compétitif.',
      record: 'Plusieurs passages en sélection mexicaine et longue expérience en Liga.',
      source: 'Fédération / FIFA'
    },
    preferredSystems: ['4-3-3', '4-2-3-1'],
    paniniLine: 'Hôte à forte pression populaire, construit pour être compétitif immédiatement.',
    attack: 'Recherche de largeur, centres et combinaisons côté fort pour créer des tirs ou seconds ballons.',
    midfield: 'Milieu batailleur, important pour tenir le rythme et alimenter les joueurs de couloir.',
    defense: 'Organisation prudente, priorité à ne pas ouvrir l’axe et à rester vivant dans le match.',
    transitions: 'Peut vite trouver les ailes, mais doit éviter les pertes dans les zones intérieures.',
    strengths: ['Expérience du coach', 'Public', 'Combativité'],
    risks: ['Pression à domicile', 'Création irrégulière'],
    tags: ['largeur', 'duel', 'hôte']
  },
  {
    id: 'canada',
    name: 'Canada',
    code: 'CAN',
    group: 'Amérique du Nord',
    status: 'Profil complet',
    coach: {
      name: 'Jesse Marsch',
      roleSince: '2024',
      formation: 'Coach marqué par les principes Red Bull : pressing, intensité, verticalité.',
      record: 'Expérience MLS, Bundesliga, Premier League et sélection canadienne.',
      source: 'Fédération / FIFA'
    },
    preferredSystems: ['4-2-2-2', '4-3-3', '4-2-3-1'],
    paniniLine: 'Vitesse, pressing et envie de transformer chaque récupération en menace.',
    attack: 'Attaque directe, appels rapides dans la profondeur et exploitation des profils puissants côté gauche/droit.',
    midfield: 'Milieu de harcèlement, fait pour fermer les passes courtes et jouer vite vers l’avant.',
    defense: 'Pressing agressif, bloc qui doit garder des distances courtes pour ne pas être transpercé.',
    transitions: 'Cœur du projet : récupérer haut, verticaliser, finir avant que l’adversaire ne se replace.',
    strengths: ['Vitesse', 'Pressing', 'Transitions'],
    risks: ['Espace si pressing battu', 'Gestion de possession longue'],
    tags: ['vertical', 'pressing', 'vitesse']
  },
  {
    id: 'japan',
    name: 'Japon',
    code: 'JPN',
    group: 'Asie',
    status: 'Profil complet',
    coach: {
      name: 'Hajime Moriyasu',
      roleSince: '2018',
      formation: 'Sélectionneur installé, habitué aux ajustements en cours de match.',
      record: 'Huitième de finaliste Coupe du monde 2022.',
      source: 'FIFA / Fédération'
    },
    preferredSystems: ['4-2-3-1', '3-4-2-1', '4-3-3'],
    paniniLine: 'Discipline collective, vitesse d’exécution et adaptation tactique.',
    attack: 'Combinaisons rapides, permutations et attaques de l’espace dès que le bloc adverse se désorganise.',
    midfield: 'Milieu propre techniquement, capable de presser puis de ressortir avec peu de touches.',
    defense: 'Bloc discipliné, coulissements nets, capacité à changer de hauteur selon l’adversaire.',
    transitions: 'Très fort dans les séquences courtes : récupération, passe rapide, attaque du côté faible.',
    strengths: ['Discipline', 'Adaptation', 'Vitesse technique'],
    risks: ['Duels aériens', 'Matchs très physiques'],
    tags: ['discipline', 'adaptation', 'côté faible']
  }
];

const TEAM_PROFILE_EN = {
  france: {
    group: 'Europe', status: 'Complete profile',
    coach: { formation: 'Former defensive midfielder, team-block culture, and short-tournament pragmatism.', record: '2018 World Cup winner, 2022 finalist.', source: 'FIFA' },
    preferredSystems: ['4-2-3-1', '4-3-3', 'hybrid 4-4-2'],
    paniniLine: 'Game-management side, strong in low moments and transitions.',
    attack: 'Looks quickly for forwards between the lines, with high value placed on deep runs and strong-side duels.',
    midfield: 'Double pivot or flexible triangle to protect turnovers, control tempo, and free creative profiles between the lines.',
    defense: 'Compact mid-block, robust box defending, pressure that is more selective than permanent depending on match context.',
    transitions: 'Very dangerous after regain: first vertical pass, runs in behind, quick finish.',
    strengths: ['Knockout-match experience', 'Attacking transitions', 'Emotional control'],
    risks: ['Possession play can be cautious', 'Reliance on rupture profiles'],
    tags: ['mid-block', 'transition', 'management']
  },
  argentina: {
    name: 'Argentina', group: 'South America', status: 'Complete profile',
    coach: { formation: 'Pragmatic national-team coach who came through the staff before stabilizing the group.', record: '2022 World Cup winner, Copa América 2021 and 2024.', source: 'FIFA' },
    paniniLine: 'Defending champion, able to shift from calm control to intense duels.',
    attack: 'Relational attack with many short supports, compensations, and freedom around the central playmaker.',
    midfield: 'Dense midfield, aggressive after loss, built to protect creators and win second balls.',
    defense: 'Disciplined block, measured full-backs, strong central defense in duels and cover.',
    transitions: 'Alternates retention and acceleration: the team can break rhythm then attack space.',
    strengths: ['Winning culture', 'Highly competitive midfield', 'Rhythm variety'],
    risks: ['Managing the generational handover', 'Creation when the center is closed'],
    tags: ['control', 'duel', 'rhythm']
  },
  brazil: {
    name: 'Brazil', group: 'South America', status: 'Complete profile',
    coach: { formation: 'Elite manager, strong culture of adaptation and framed freedom.', record: 'Multiple Champions League winner with several clubs.', source: 'FIFA' },
    preferredSystems: ['4-3-3', '4-2-3-1', '4-4-2 diamond'],
    paniniLine: 'Pure talent, now framed by very experienced game management.',
    attack: 'Freedom for wingers and creators, looking for favorable isolations and quick switches.',
    midfield: 'Usually balanced structure: a security base behind profiles able to carry or break a line.',
    defense: 'More patient block, intent to limit open matches and better protect against opposition transitions.',
    transitions: 'Strong potential right after regains, especially if first relays find wide areas quickly.',
    strengths: ['Offensive 1v1', 'Technical quality', 'Coach experience'],
    risks: ['Attack-defense balance', 'Sometimes discontinuous pressing'],
    tags: ['talent', 'width', 'balance']
  },
  england: {
    name: 'England', group: 'Europe', status: 'Complete profile',
    coach: { formation: 'Very structured club coach, used to hybrid attacking shapes.', record: 'Champions League and Club World Cup winner with Chelsea.', source: 'FIFA' },
    paniniLine: 'Premium squad, coach highly interventionist in tactical details.',
    attack: 'Looks for superiority between the lines, alternating strict width and interior players in half-spaces.',
    midfield: 'Double pivot or midfield three to secure first build-up and free attacking profiles.',
    defense: 'Zone-organized pressing, desire to defend forward without exposing the center too early.',
    transitions: 'Can attack very quickly if regains find creators facing play.',
    strengths: ['Bench depth', 'Set pieces', 'System flexibility'],
    risks: ['National-team automatisms', 'Media pressure'],
    tags: ['hybrid', 'pressing', 'half-spaces']
  },
  spain: {
    name: 'Spain', group: 'Europe', status: 'Complete profile',
    coach: { formation: 'Spanish federation culture, strong links with younger generations.', record: 'Euro 2024 champion.', source: 'Federation / UEFA' },
    paniniLine: 'Less dogmatic possession, more vertical and cutting.',
    attack: 'Important width, aggressive wingers, interior play to attract then accelerate on the opposite side.',
    midfield: 'Technical midfield that controls intervals, keeps the ball under pressure, and prepares counter-pressing.',
    defense: 'High counter-press after loss, advanced defensive line if pressure on the ball is good.',
    transitions: 'High regains are valued, but the side can calm things down immediately if the situation is not clear.',
    strengths: ['Collective control', 'Impactful wingers', 'Counter-pressing'],
    risks: ['Space in behind', 'Isolated defensive duels'],
    tags: ['possession', 'width', 'counter-pressing']
  },
  portugal: {
    group: 'Europe', status: 'Complete profile',
    coach: { formation: 'Possession-oriented coach with modular structures.', record: 'Long international experience with Belgium, then Portugal.', source: 'Federation / UEFA' },
    paniniLine: 'Very rich generation, able to change outfit without changing match.',
    attack: 'Many rotations between full-backs, midfielders, and wide players to create overloads.',
    midfield: 'Creative midfield, often tasked with fixing opponents and directing play into finishing zones.',
    defense: 'Back three or four depending on phase, with strong attention to cover behind full-backs.',
    transitions: 'Very dangerous attacking transitions if wide players launch at speed.',
    strengths: ['Offensive variety', 'Passing quality', 'Deep bench'],
    risks: ['Balancing the stars', 'Defending high turnovers'],
    tags: ['rotation', 'creation', 'width']
  },
  germany: {
    name: 'Germany', group: 'Europe', status: 'Complete profile',
    coach: { formation: 'Modern coach, very focused on asymmetric structures.', record: 'High-level Bundesliga and national-team experience.', source: 'Federation / UEFA' },
    paniniLine: 'Young, aggressive project with many ideas for occupying zones.',
    attack: 'Mobile positional play, creations in half-spaces, full-back or center-back able to break the structure.',
    midfield: 'Technical base to play out cleanly, then quick verticality toward players between the lines.',
    defense: 'Ambitious high press, with preventive cover essential to avoid suffering long balls.',
    transitions: 'Strong counter-pressing focus, even if it accepts some risk behind.',
    strengths: ['Worked structure', 'Pressing', 'Explosive young profiles'],
    risks: ['Space behind the line', 'Stability under pressure'],
    tags: ['asymmetry', 'high press', 'verticality']
  },
  morocco: {
    name: 'Morocco', group: 'Africa', status: 'Complete profile',
    coach: { formation: 'Pragmatic national-team coach, strong on collective identity.', record: '2022 World Cup semi-finalist.', source: 'FIFA / Federation' },
    paniniLine: 'Solid block, fast transitions, very strong collective emotion.',
    attack: 'Quick exits wide, looking for players who can carry the ball upfield.',
    midfield: 'Protection midfield, useful to close the center then support transitions.',
    defense: 'Very compact mid/low block, brave box defending, heavy wide-channel work.',
    transitions: 'Immediate projection after regains, especially when the opponent has committed numbers.',
    strengths: ['Collective solidity', 'Transitions', 'Tournament mentality'],
    risks: ['Creation against low blocks', 'Defensive fatigue if pinned back too long'],
    tags: ['compact block', 'transition', 'channels']
  },
  usa: {
    name: 'United States', group: 'North America', status: 'Complete profile',
    coach: { formation: 'Intense coach focused on pressing, verticality, and physical standards.', record: 'Major experience in the Premier League, Ligue 1, and European cups.', source: 'Federation / FIFA' },
    paniniLine: 'Host nation with energy, pressing, and young transition profiles.',
    attack: 'Direct play when space appears, intent to add tempo and attack wide channels quickly.',
    midfield: 'Athletic midfield, often decisive for pressing, covering, and feeding forward runs.',
    defense: 'Desired high pressure, with a block that must stay compact to avoid gaps between lines.',
    transitions: 'Excellent terrain for Pochettino: regain, vertical run, quick attack.',
    strengths: ['Intensity', 'Athleticism', 'Host-nation effect'],
    risks: ['Control against set blocks', 'Managing weaker periods'],
    tags: ['pressing', 'speed', 'host']
  },
  mexico: {
    name: 'Mexico', group: 'North America', status: 'Complete profile',
    coach: { formation: 'Experienced national-team coach, pragmatic and competitive profile.', record: 'Several spells with Mexico and long Liga experience.', source: 'Federation / FIFA' },
    paniniLine: 'Host under strong popular pressure, built to be competitive immediately.',
    attack: 'Looks for width, crosses, and strong-side combinations to create shots or second balls.',
    midfield: 'Combative midfield, important to hold rhythm and feed wide players.',
    defense: 'Prudent organization, priority on not opening the center and staying alive in the match.',
    transitions: 'Can find the wings quickly, but must avoid losses in interior zones.',
    strengths: ['Coach experience', 'Crowd', 'Competitiveness'],
    risks: ['Home pressure', 'Irregular creation'],
    tags: ['width', 'duel', 'host']
  },
  canada: {
    name: 'Canada', group: 'North America', status: 'Complete profile',
    coach: { formation: 'Coach marked by Red Bull principles: pressing, intensity, verticality.', record: 'MLS, Bundesliga, Premier League, and Canadian national-team experience.', source: 'Federation / FIFA' },
    paniniLine: 'Speed, pressing, and desire to turn every regain into a threat.',
    attack: 'Direct attack, quick runs in behind, and use of powerful profiles on both sides.',
    midfield: 'Harassment midfield, built to close short passes and play forward quickly.',
    defense: 'Aggressive pressing, with a block that must keep short distances to avoid being broken through.',
    transitions: 'Core of the project: win it high, go vertical, finish before the opponent resets.',
    strengths: ['Speed', 'Pressing', 'Transitions'],
    risks: ['Space if press is beaten', 'Managing long possession'],
    tags: ['vertical', 'pressing', 'speed']
  },
  japan: {
    name: 'Japan', group: 'Asia', status: 'Complete profile',
    coach: { formation: 'Established national-team coach, used to in-game adjustments.', record: '2022 World Cup round of 16.', source: 'FIFA / Federation' },
    paniniLine: 'Collective discipline, speed of execution, and tactical adaptation.',
    attack: 'Quick combinations, rotations, and attacks into space as soon as the opposition block loses shape.',
    midfield: 'Technically clean midfield, able to press then play out with few touches.',
    defense: 'Disciplined block, clean shifts, ability to change height depending on opponent.',
    transitions: 'Very strong in short sequences: regain, quick pass, attack the weak side.',
    strengths: ['Discipline', 'Adaptation', 'Technical speed'],
    risks: ['Aerial duels', 'Very physical matches'],
    tags: ['discipline', 'adaptation', 'weak side']
  }
};

function localizeTeam(team) {
  const en = TEAM_PROFILE_EN[team.id];
  if (!usesEnglishContentFallback() || !en) return team;
  return {
    ...team,
    ...en,
    coach: { ...team.coach, ...(en.coach || {}) },
    strengths: en.strengths || team.strengths,
    risks: en.risks || team.risks,
    tags: en.tags || team.tags,
    preferredSystems: en.preferredSystems || team.preferredSystems
  };
}

export function listTeamProfiles() {
  return TEAM_PROFILES.map(localizeTeam).sort((a, b) => a.name.localeCompare(b.name, currentLocale()));
}

export function findTeamProfile(id) {
  return localizeTeam(TEAM_PROFILES.find((team) => team.id === id) || TEAM_PROFILES[0]);
}

export function localizedProfileDataset() {
  return {
    ...PROFILE_DATASET,
    competition: tr(PROFILE_DATASET.competition, '2026 World Cup'),
    sourceNote: tr(PROFILE_DATASET.sourceNote, 'Sources: FIFA, UEFA, and federations; dated Foot-debrief editorial synthesis, review before each match.')
  };
}
